import { useListCustomProperties } from '@repo/api-codegen';
import { FilterOptionType } from '@repo/common/components/Filter/types';
import { EntityType } from '@repo/common/enums/entityType';
import { useMemo } from 'react';
import type { IColumn, ISecodaEntity } from '../../../../api';
import type { ICommandListItem } from '../../../../components/Spotlight/components/CommandPalette/constants';
import { useGenericColumns } from '../../../../components/TableV2/SecodaEntity.hooks';
import {
	CapitalizeTextRender,
	ColumnProfileRender,
} from '../../../../components/TableV2/render';
import type {
	ExtendedDataTableColumn,
	Render,
} from '../../../../components/TableV2/types';
import { useActions as useCatalogActions } from '../../../TeamCatalogPage/TeamCatalogPage.hooks';
import { getSemanticViewColumns } from './SemanticView';

export function useColumns({
	forceReadOnly = false,
	table,
	entityType = EntityType.column,
}: {
	forceReadOnly?: boolean;
	table?: ISecodaEntity;
	entityType?: EntityType;
} = {}): ExtendedDataTableColumn<IColumn>[] {
	const genericColumns = useGenericColumns({ forceReadOnly });
	const { data: customProperties } = useListCustomProperties({});

	const isSemanticView =
		table?.native_type === 'semantic_view' ||
		table?.native_type === 'dbt_semantic_model';

	const columns = useMemo(
		() => [
			// Hide the normal Type column for semantic views
			...(isSemanticView
				? []
				: [
						{
							accessor: 'type',
							titleLabel: 'Type',
							width: 160,
							render: (record: IColumn) => (
								<CapitalizeTextRender<IColumn>
									record={record}
									field={'type'}
									field2={'native_type'}
								/>
							),
							filterOptionType: FilterOptionType.NATIVE_TYPE,
						},
					]),
			...(isSemanticView
				? getSemanticViewColumns(entityType, customProperties)
				: []),
			...genericColumns,
			{
				accessor: 'profile_data.ntiles',
				titleLabel: 'Distribution',
				sortable: false,
				filtering: false,
				explicit: true,
				width: 160,
				render: ColumnProfileRender as unknown as Render<IColumn>,
			},
		],
		[genericColumns, isSemanticView, entityType, customProperties]
	);

	return columns;
}
export const useActions = () => {
	const actions = useCatalogActions() as unknown as ICommandListItem<IColumn>[];

	return actions;
};
